export default function Services() {
  const services = [
    {
      title: 'Heating Installation & Repair',
      description: 'Furnace installation, repair, and maintenance for optimal winter comfort',
      icon: 'ri-fire-line',
      bgColor: 'bg-orange-400',
      textColor: 'text-white',
      image: null,
    },
    {
      title: 'AC Maintenance & Replacement',
      description: 'Complete air conditioning services to keep you cool all summer',
      icon: 'ri-snowy-line',
      bgColor: 'bg-teal-500',
      textColor: 'text-white',
      image: 'https://public.readdy.ai/ai/img_res/7d98e38e015663dbefb3b3904ea5eddc.jpg',
    },
    {
      title: '24/7 Emergency HVAC Service',
      description: 'Available nights, weekends and holidays for urgent repairs',
      icon: 'ri-24-hours-line',
      bgColor: 'bg-black',
      textColor: 'text-white',
      image: null,
    },
    {
      title: 'Annual Maintenance Plans',
      description: 'Preventive care packages to extend system life and improve efficiency',
      icon: 'ri-calendar-check-line',
      bgColor: 'bg-gray-100',
      textColor: 'text-gray-800',
      image: 'https://readdy.ai/api/search-image?query=professional-hvac-technician-with-checklist-performing-maintenance-inspection-residential-hvac-system-clean-uniform-professional-tools-bright-indoor-lighting-service-quality-detailed-equipment-check&width=600&height=400&seq=service-maintenance-1&orientation=landscape',
    },
  ];

  return (
    <section id="services" className="py-20 bg-amber-50" data-product-shop>
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-12">
          <p className="text-xs uppercase tracking-wider text-gray-500 mb-2">WHAT WE OFFER</p>
          <h2 className="text-4xl md:text-5xl font-serif text-gray-900">Our Services</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className={`${service.bgColor} rounded-3xl p-8 relative overflow-hidden cursor-pointer hover:scale-105 transition-transform duration-300`}
            >
              {service.image ? (
                <>
                  <div className="absolute inset-0">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover object-center"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
                  </div>
                  <div className="relative z-10">
                    <div className="flex items-center gap-2 mb-4 bg-black/60 backdrop-blur-sm rounded-full px-4 py-2 w-fit">
                      <i className={`${service.icon} text-xl text-white`}></i>
                      <span className="text-xs uppercase tracking-wide text-white font-medium">
                        {service.title.split(' ')[0]}
                      </span>
                    </div>
                    <h3 className="text-2xl font-bold text-white mb-3">{service.title}</h3>
                    <p className="text-sm text-gray-200">{service.description}</p>
                  </div>
                </>
              ) : (
                <>
                  <div className="w-14 h-14 bg-black/20 rounded-full flex items-center justify-center mb-6">
                    <i className={`${service.icon} text-3xl ${service.textColor}`}></i>
                  </div>
                  <h3 className={`text-2xl font-bold ${service.textColor} mb-3`}>{service.title}</h3>
                  <p className={`text-sm ${service.textColor === 'text-white' ? 'text-gray-200' : 'text-gray-600'}`}>
                    {service.description}
                  </p>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
